import { render, staticRenderFns } from "./QuestionAsk.vue?vue&type=template&id=14085499&scoped=true&"
import script from "./QuestionAsk.vue?vue&type=script&lang=js&"
export * from "./QuestionAsk.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAsk.vue?vue&type=style&index=0&id=14085499&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14085499",
  null
  
)

export default component.exports